export const DestinationListV3: DestinationListTypeV3[] = [
    {
        "Searc ID": 10271,
        airport_code: "AGA",
        "Display Name #1": "Agadir, Morocco",
      },
      {
        "Searc ID": 10628,
        airport_code: "AYT",
        "Display Name #1": "Antalya, Turkey",
      },
      {
        "Searc ID": 11166,
        airport_code: "BJV",
        "Display Name #1": "Bodrum, Turkey",
      },
      {
        "Searc ID": 32612,
        airport_code: "CFU",
        "Display Name #1": "Corfu, Greece",
      },
      {
        "Searc ID": 32613,
        airport_code: "HER",
        "Display Name #1": "Crete, Greece",
      },    
      {
        "Searc ID": 11828,
        airport_code: "DLM",
        "Display Name #1": "Dalaman, Turkey",
      },
      {
        "Searc ID": 11739,
        airport_code: "DBV",
        "Display Name #1": "Dubrovnik, Croatia",
      },
      {
        "Searc ID": 12196,
        airport_code: "FAO",
        "Display Name #1": "Faro, Portugal",
      },
      {
        "Searc ID": 12270,
        airport_code: "FLR",
        "Display Name #1": "Florence, Italy",
      },
      {
        "Searc ID": 12354,
        airport_code: "FUE",
        "Display Name #1": "Fuerteventura, Canary Islands",
      },
      {
        "Searc ID": 12286,
        airport_code: "FNC",
        "Display Name #1": "Funchal, Portugal",
      },
      {
        "Searc ID": 14104,
        airport_code: "LPA",
        "Display Name #1": "Gran Canaria, Canary Islands",
      },
       
      {
        "Searc ID": 32614,
        airport_code: "SKG",
        "Display Name #1": "Halkidiki, Greece",
      },
      {
        "Searc ID": 12987,
        airport_code: "IBZ",
        "Display Name #1": "Ibiza, Spain",
      },
      {
        "Searc ID": 13484,
        airport_code: "KGS",
        "Display Name #1": "Kos, Greece",
      },
      {
        "Searc ID": 10218,
        airport_code: "ACE",
        "Display Name #1": "Lanzarote,Canary Islands",
      },
      {
        "Searc ID": 13894,
        airport_code: "LCA",
        "Display Name #1": "Larnaca, Cyprus",
      },
      {
        "Searc ID": 10284,
        airport_code: "AGP",
        "Display Name #1": "Malaga - Costa Del Sol,Spain",
      },
      {
        "Searc ID": 14516,
        airport_code: "MLA",
        "Display Name #1": "Malta, Malta",
      },
      {
        "Searc ID": 16429,
        airport_code: "RAK",
        "Display Name #1": "Marrakech, Morocco",
      },
      {
        "Searc ID": 14267,
        airport_code: "MAH",
        "Display Name #1": "Menorca, Spain",
      },
      {
        "Searc ID": 14456,
        airport_code: "MXP",
        "Display Name #1": "Milan, Italy",
      },
      {
        "Searc ID": 13294,
        airport_code: "JMK",
        "Display Name #1": "Mykonos, Greece",
      },
      {
        "Searc ID": 14879,
        airport_code: "NAP",
        "Display Name #1": "Naples, Italy",
      },
      {
        "Searc ID": 15634,
        airport_code: "PMI",
        "Display Name #1": "Palma Mallorca, Spain",
      },
      {
        "Searc ID": 15508,
        airport_code: "PFO",
        "Display Name #1": "Paphos, Cyprus",
      },
      {
        "Searc ID": 15820,
        airport_code: "PUY",
        "Display Name #1": "Pula, Croatia",
      },
      {
        "Searc ID": 16534,
        airport_code: "RHO",
        "Display Name #1": "Rhodes, Greece",
      },
      {
        "Searc ID": 16607,
        airport_code: "FCO",
        "Display Name #1": "Rome, Italy",
      },
    
      {
        "Searc ID": 32620,
        airport_code: "JTR",
        "Display Name #1": "Santorini, Greece",
      },
      {
        "Searc ID": 17080,
        airport_code: "SPU",
        "Display Name #1": "Split, Croatia",
      },
      {
        "Searc ID": 17368,
        airport_code: "TFS",
        "Display Name #1": "Tenerife, Canary Islands",
      },
      {
        "Searc ID": 17968,
        airport_code: "VCE",
        "Display Name #1": "Venice, Italy",
      },
      {
        "Searc ID": 18074,
        airport_code: "VRN",
        "Display Name #1": "Verona, Italy",
      },
     
      {
        "Searc ID": 19290,
        airport_code: "ZTH",
        "Display Name #1": "Zakinthos, Greece",
      }
    ]